export function mapPeriodo(data) {
  if (!data || typeof data !== "object") return null;

  return {
    id: data.id_tipo_periodo ?? null,
    institucionId: data.id_institucion ?? null,
    institucion: data.id_institucion ?? null,
    nombre: data.nombre_periodo ?? "",
    codigo: data.codigo_periodo ?? "",
    numPorAno: data.periodos_por_anio ?? "",
    duracion: data.duracion_semanas ?? "",
    descripcion: data.descripcion ?? "",
    estado: data.activo ? "ACTIVO" : "INACTIVO",
  };
}
